import React, {
    FC, useState, useEffect, ReactElement
} from 'react';
import {
    View, Flex
} from '@adobe/react-spectrum';
import { DeleteButton } from './deleteButton';

interface IDeletableProps {
    children: ReactElement;
    title: string;
    onDelete: () => void;
    hide?: boolean;
}

const Delete_Icon_Size = 16;

export const Deletable: FC<IDeletableProps> = ({
    children, title, onDelete, hide
}: IDeletableProps) => {
    const [hovered, setHovered] = useState<boolean>(false);

    useEffect(() => {
        if (hide) setHovered(false);
    }, [hide]);

    return (
        <div
            onMouseEnter={() => { if (onDelete && !hide) setHovered(true); }}
            onMouseLeave={() => { setHovered(false); }}
        >
            <Flex direction="column" position="relative">
                {children}
                {hovered && (
                    <View
                        position="absolute"
                        top={`-${Delete_Icon_Size / 3}px`}
                        right={`-${Delete_Icon_Size / 3}px`}
                        zIndex={100}
                    >
                        <DeleteButton
                            onOpenChange={(isOpen) => { if (!isOpen) setHovered(false); }}
                            onDelete={onDelete}
                            title={title}
                            size={Delete_Icon_Size}
                        />
                    </View>
                )}
            </Flex>
        </div>

    );
};

Deletable.defaultProps = {
    hide: false,
};
